import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { AssetMini } from 'elements-sdk'

@Component({
  selector: 'asset-icon',
  templateUrl: './assetIcon.component.pug',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    'aria-role': 'img',
  },
})
export class AssetIconComponent {
  @Input() asset: AssetMini|null

  get iconClass () {
    return {
      image: 'fa-file-image',
      pdf: 'fa-file-pdf',
      office: 'fa-file-word',
      video: 'fa-file-video',
      audio: 'fa-file-audio',
      fcpxml: 'fa-film',
      fcpxxml: 'fa-film',
      prproj: 'fa-film',
      aep: 'fa-film',
      avp: 'fa-film',
      model: 'fa-cube',
      subtitle: 'fa-closed-captioning',
    }[this.asset?.type ?? ''] ?? 'fa-file'
  }

  get imageURL () {
    return {
      fcpxml: '/assets/asset-icons/fcpxml.png',
      fcpxxml: '/assets/asset-icons/fcpxxml.png',
      prproj: '/assets/asset-icons/premiere.png',
      aep: '/assets/asset-icons/aftereffects.png',
      avp: '/assets/asset-icons/avid.png',
    }[this.asset?.type ?? '']
  }

  get imageAltText () {
    return {
      fcpxml: 'FCPXML',
      fcpxxml: 'FCPXXML',
      prproj: 'Premiere',
      aep: 'After Effects',
      avp: 'Avid',
    }[this.asset?.type ?? '']
  }
}
